

import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PlayerSesionComponent } from './components/player-sesion/player-sesion.component';
import {canActivate, redirectLoggedInTo, redirectUnauthorizedTo}from '@angular/fire/compat/auth-guard';
import { RegisterComponent } from './components/register/register.component';

const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['landing']);

const routes: Routes = [
  {
    path: 'home',
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule),
    ...canActivate(redirectLoggedInToHome),

  },
  {
    path: 'login',
    ...canActivate(redirectLoggedInToHome),
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule),
    
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'crear-perfil',
    loadChildren: () => import('./pages/crear-perfil/crear-perfil.module').then( m => m.CrearPerfilPageModule)
  },
  {
    path: 'categorie-detail/:categorie',
    loadChildren: () => import('./pages/categorie-detail/categorie-detail.module').then( m => m.CategorieDetailPageModule)
    
  },
  {
    path: 'frase-del-dia/:section',
    loadChildren: () => import('./pages/frase-del-dia/frase-del-dia.module').then( m => m.FraseDelDiaPageModule)
  },
  {
    path: 'course-detail/:categorie/:id',
    loadChildren: () => import('./pages/course-detail/course-detail.module').then( m => m.CourseDetailPageModule)
  },
  {
    path: 'iniciacionesgrima',
    loadChildren: () => import('./pages/iniciacionesgrima/iniciacionesgrima/iniciacionesgrima.module').then( m => m.IniciacionesgrimaPageModule)
  },
  {
    path: 'course-detail-esgrima/:id',
    loadChildren: () => import('./pages/course-detail-esgrima/course-detail-esgrima/course-detail-esgrima.module').then( m => m.CourseDetailEsgrimaPageModule)
  },
  {
    path: 'onlive/:event/:callback',
    loadChildren: () => import('./pages/onlive/onlive.module').then( m => m.OnlivePageModule)
  },
  {
    path: 'sesion/:id',
    component:PlayerSesionComponent
    // loadChildren: () => import('./pages/sesion/sesion.module').then( m => m.SesionPageModule)
  },
  {
    path: 'herir',
    loadChildren: () => import('./pages/herir/herir.module').then( m => m.HerirPageModule)
  },
  {
    path: 'ejerciciosrapidos',
    loadChildren: () => import('./pages/ejerciciosrapidos/ejerciciosrapidos.module').then( m => m.EjerciciosrapidosPageModule)
  },
  {
    path: 'ejercicio/:ejercicio',
    loadChildren: () => import('./pages/ejercicio/ejercicio.module').then( m => m.EjercicioPageModule)
  },
  {
    path: 'pagos',
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('./pages/pagos/pagos.module').then( m => m.PagosPageModule)
  },
  {
    path: 'pagos-cursos',
    loadChildren: () => import('./pages/pagos-cursos/pagos-cursos.module').then( m => m.PagosCursosPageModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./pages/checkout/checkout.module').then( m => m.CheckoutPageModule)
  },
  {
    path: 'simuladores',
    loadChildren: () => import('./pages/simuladores/simuladores.module').then( m => m.SimuladoresPageModule)
  },
  {
    path: 'profile',
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'clase-individual',
    loadChildren: () => import('./pages/clase-individual/clase-individual.module').then( m => m.ClaseIndividualPageModule)
  },








];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

